import { ReactNode } from 'react';

export function EmptyState({
  title, body, action,
}: {
  title: string;
  body?: string;
  action?: ReactNode;
}) {
  return (
    <div className="text-center py-16 border border-dashed border-line rounded-lg bg-white">
      <div className="text-base font-medium">{title}</div>
      {body && <div className="text-sm text-muted mt-1 max-w-sm mx-auto">{body}</div>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
